module.exports = __webpack_public_path__ + "img/10.3324a90d.png";